import React from 'react';
import clsx from 'clsx';
import shareButtonStyles from './ShareButton.module.scss';
import Checkmark from './Checkmark';

export const CopyButtonIcon: React.FC<{ labelNode: React.ReactNode }> = ({
  labelNode,
}) => {
  return (
    <span className={clsx(shareButtonStyles.root)}>
      <span className={clsx(shareButtonStyles.checkmark, 'icon')}>
        <Checkmark />
      </span>
      {labelNode}
    </span>
  );
};
